
export default {
  components: {
    SpCarousel: () => import("~/components/v2/splash/sp-carousel.vue"),
    // ProfileCardV2: () =>
    //   import("~/components/v2/profile-card/profile-card.vue"),
  },
  props: {
    // 'female' | 'day' | 'quality-mark' | 'new' | 'shemale' | 'male'
    type: { type: String, required: true },
  },

  head() {
    if (!this.profiles?.length) return {};
    return {
      script: [
        {
          hid: `jsonld-${this.type}`,
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: this.title,
            url: `${this.$config.baseUrlApp}${this.href}`,
            itemListElement: this.profiles.map((profile, index) => ({
              "@type": "ListItem",
              position: index + 1,
              url: `${this.$config.baseUrlApp}/profile/${profile.slug}`,
              name: profile.name,
              image: profile.mainPhoto,
            })),
          },
        },
      ],
    };
  },
  computed: {
    // isMobileDevice() {
    //   return this.$device.isMobile;
    // },
    profiles() {
      switch (this.type) {
        case "female":
          return this.$store.getters["sliders/getFemaleCarouselData"];
        case "day":
          return this.$store.getters["sliders/getGirlOfTheDayData"];
        case "qm":
          return this.$store.getters["sliders/getQmCarouselData"];
        case "new":
          return this.$store.getters["sliders/getNewCarouselData"];
        case "shemale":
          return this.$store.getters["sliders/getTransgenderCarouselData"];
        case "male":
          return this.$store.getters["sliders/getMaleCarouselData"];
        default:
          return [];
      }
    },
    title() {
      switch (this.type) {
        case "female":
          return "Escort girls";
        case "day":
          return "Girl of the Day";
        case "qm":
          return "Quality mark escorts";
        case "new":
          return "New escorts";
        case "shemale":
          return "Shemale escorts";
        case "male":
          return "Male escorts";
        default:
          return [];
      }
    },
    btnText() {
      switch (this.type) {
        case "female":
          return "Show all girls escorts";
        case "day":
          return "Show all girls escorts";
        case "qm":
          return "Show all quality mark escorts";
        case "new":
          return "Show all new escorts";
        case "shemale":
          return "Show all shemale escorts";
        case "male":
          return "Show all male escorts";
        default:
          return [];
      }
    },
    href() {
      switch (this.type) {
        case "female":
          return "/dubai/female";
        case "day":
          return "/dubai/female";
        case "qm":
          return "/dubai/female/quality-mark";
        case "new":
          return "/dubai/female/new";
        case "shemale":
          return "/dubai/transgender";
        case "male":
          return "/dubai/male";
        default:
          return "/";
      }
    },
    mobileCards() {
      return (this.profiles || []).slice(0, 4);
    },
  },
};
